module.exports = __webpack_public_path__ + "k-icons.1595226992386.svg";